import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { 
  LOCALSESSIONDATAKEYS,  
  SIGNUPTYPE, 
  featureSwitchName, 
  refreshBtn, 
  tryAgainBtn 
} from "../../../../../../constants/AppConstants";
import { setLocalSessionData, WEB_handleSelectedPlanLocalData } from "../../../../../../utils/Authentication/handleUserSession";
import { WebCustomerRoutePaths } from "../../../../../../constants/Routes";
import Loader from "../../../../../../components/shared/loader/Loader";
import WebSubHeader from "../../../../../../components/WebSubHeader/WebSubHeader";
import ListPlan from "../../../../../../components/Web/Customer/ListPlan/ListPlan";
import { FetchServicePlan } from "../../../../../../actions/Web/Customer/SignUp";
import ErrorPage from "../../../../../../components/shared/errorPage/ErrorPage";
import { getPromotionsArray, Is_BrotherPlus_Signup, pushDataLayer, isPromotionApplicable } from "../../../../../../constants/AppMethod";
import check from "../../../../../../assets/images/planFeaturecheck.svg";
import WebSignupProgressBar from "../../../../../../components/WebSubHeader/progressBar/WebSignupProgressBar";
import FAQPlansPage from "../../../../../../components/SelectPlan/FAQ/FAQ";
import LearnMore from "../../../../../../components/SelectPlan/LearnMore/LearnMore";
import PromotionBanner from "../../../../../../components/shared/PromotionBanner/PromotionBanner";
import CaveatText from "../../../../../../components/SelectPlan/CaveatText/CaveatText";
import EasyPayPlan from "../../../../../../components/Web/Customer/BrotherPlus/EasyPayPlan/EasyPayPlan";
import { fetchFeatureSwitchByMultipleValuesRequest } from "../../../../../../store/FeatureSwitchByMultipleValues/FeatureSwitchByMultipleValuesSlice";
import PlannedMaintenance from "../../../../../../components/PlannedMaintenance/PlannedMaintenance";

const WebSelectPlan = (props) => {
  const { location } = props;
  const dispatch = useDispatch();
  const result = useSelector((state) => state.WebServicePlan);
  const { t } = useTranslation(["translation"]);
  const printerModel = location?.state?.printer_model;
  const history = useHistory();
  const totalSlides = result?.webServicePlan?.length;
  const IsBrotherPlus_Signup = Is_BrotherPlus_Signup();
  const FeatureSwitchByMultipleValues = useSelector((state) => state.FeatureSwitchByMultipleValues)
  const { featureSwitchByMultipleValues} = FeatureSwitchByMultipleValues;
  const MaintenanceBanners= featureSwitchByMultipleValues?.MaintenanceBanners || null
  const BonusPages= featureSwitchByMultipleValues?.BonusPages || false;
  const BrotherPlusProgram= featureSwitchByMultipleValues?.BrotherPlusProgram;
  const PromotionBanners= featureSwitchByMultipleValues?.PromotionBanners;
  const payloadForFeatureSwitch=`${featureSwitchName.PROMOTION_BANNERS},${featureSwitchName.BONUS_PAGES},${featureSwitchName.BROTHER_PLUS},${featureSwitchName.MAINTENENCE_BANNERS}`

  const [hasActivePromotion, setHasActivePromotion] = useState(false);

  useEffect(() => {
    dispatch(fetchFeatureSwitchByMultipleValuesRequest(payloadForFeatureSwitch));
     // eslint-disable-next-line
  },[dispatch, IsBrotherPlus_Signup]
)

  useEffect(() => {
    if(printerModel){
      const promotions = getPromotionsArray(printerModel,BonusPages);
      dispatch(FetchServicePlan(printerModel,promotions));
    }
  }, [dispatch, printerModel, BonusPages]);

  useEffect(() => {
    const plansList = (result.hasOwnProperty("webServicePlan") &&
      result.webServicePlan.length > 0) ? result.webServicePlan : null;
    setHasActivePromotion(isPromotionApplicable(plansList));
  }, [result]);

  const moveToAccountPage = (selectedPlan) => {
    pushDataLayer('plan_selected','plan_id',selectedPlan.planId)
    setLocalSessionData(LOCALSESSIONDATAKEYS.CURRENCY, selectedPlan.currency);
    WEB_handleSelectedPlanLocalData("Set", selectedPlan);
    history.push({pathname: WebCustomerRoutePaths.WEB_REDIRECT, state:{'signupType': SIGNUPTYPE.WEB}});
  };
  const moveToPreviousPage = () => {
    history.push(WebCustomerRoutePaths.SELECT_PRINTER);
  }

  if(!printerModel){
    return <ErrorPage errorInfo={t('ERROR_CONTENT.ERR_INFO.SELECT_A_DEVICE')} showTryAgain={tryAgainBtn.SHOW} to={WebCustomerRoutePaths.SELECT_PRINTER}></ErrorPage>
  }
  if (result.loading) {
    return <Loader></Loader>;
  }
  if(result.error) {
    return <ErrorPage errorInfo={result.error} showRefreshBtn={refreshBtn.HIDE}></ErrorPage>
  }
  if(totalSlides === 0) {
    return <ErrorPage errorInfo={t('ERROR_CONTENT.No_PLANS')} showRefreshBtn={refreshBtn.HIDE}></ErrorPage>
  }

 const planFeature = (
  <div className="plan-feature-wrapper">
    <div className="plan-feature">
      <li>
        <img src={check} alt="plan-point" />
        <span>{t("CUSTOMER_WEB.SELECT_PLAN.EXTENDED_WARRANTY")}</span>
      </li>
      <li>
        <img src={check} alt="plan-point" />
        <span>{t("CUSTOMER_WEB.SELECT_PLAN.CANCEL_ANYTIME")}</span>
      </li>
      <li>
        <img src={check} alt="plan-point" />
        <span>{t("CUSTOMER_WEB.SELECT_PLAN.FREE_DELIVERY")}</span>
      </li>
    </div>
  </div>
 )

  return (
    <>
      {(!IsBrotherPlus_Signup && hasActivePromotion) ? <PromotionBanner/> : null}
      <PlannedMaintenance showMaintenanceBanner={MaintenanceBanners}/>
      <WebSignupProgressBar activeStep = {2} />
      <WebSubHeader
            currentStep="2"
            totalStep="4"
            stepName={t('SUB_HEADER.STEP_2.STEP_NAME')}
            stepInfo={t('SUB_HEADER.STEP_2.STEP_INFO')}
            moveToPreviousPage={moveToPreviousPage}
            previousBtnText={t('CUSTOMER_WEB.SELECT_PLAN.DEVICE_SELECTION')}
            planFeature={planFeature}
            hideStepInfo={true}
            withProgressBar={true}
      />
      <ListPlan isBrotherPlusProgramEnabled={BrotherPlusProgram} plansData={result} moveToAccountPage={moveToAccountPage}  isPromotionBannerEnabled = {PromotionBanners ? true : false} />
      
      {BrotherPlusProgram &&
        <EasyPayPlan/>
      }
      <FAQPlansPage />
      <LearnMore />
      <CaveatText signupType={SIGNUPTYPE.WEB}/>
    </>
  );
};

export default WebSelectPlan;
